// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2jY5w","choiceBoxes":"toolbarselects_choiceBoxes__2Dcmh","simpleField":"toolbarselects_simpleField__3t3Mu"};